import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { AppState } from '../../core/redux/appState';
import { Action } from 'redux';


type OpenMenuAction = {
  type: ActionType.OpenMenu;
  setOpen: boolean;
}


/**
 * Dispatch this action to open/close the app's side menu.
 * @param setOpen - the new open state you want (default: open)
 */
export const openMenuAction = (setOpen: boolean = true): OpenMenuAction => ({
  type:    ActionType.OpenMenu,
  setOpen: setOpen,
});


export const openMenuReducer = (state: AppState, incomingAction: Action): AppState => {
  if (incomingAction.type !== ActionType.OpenMenu) {
    return state;
  }
  const action = incomingAction as OpenMenuAction;

  return R.assoc('openSideMenu', action.setOpen, state);
};

